import { useState } from 'react';
import { faqItems } from '@/mocks/categories';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-sm font-semibold text-primary-500 uppercase tracking-wider mb-3">FAQ</p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Najczęściej zadawane pytania
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            Wszystko, co musisz wiedzieć o Kakobuy Spreadsheet
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl border border-background-200 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {item.question}
                </h3>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-lg text-foreground-400"></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4 animate-fade-in">
                  <p className="text-sm text-foreground-500 leading-relaxed border-t border-background-200 pt-4">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}